import React from 'react'

function FormTitleECPF ({ children }: {children: React.ReactNode}) {
  return (
    <h3 className='form-title'>{children}</h3>
  )
}

export default FormTitleECPF
